import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { SpiritType } from 'src/app/products/interfaces/models';
import { SubformBaseComponent } from 'src/app/shared/components/subform-base/subform-base.component';

import { SpiritProperties } from '@app/api/models';

import { BitterPropertiesSubformComponent } from '../bitter/bitter-properties-subform/bitter-properties-subform.component';
import { CognacPropertiesSubformComponent } from '../cognac/cognac-properties-subform/cognac-properties-subform.component';
import { FruitSpiritPropertiesSubformComponent } from '../fruit-spirit/fruit-spirit-properties-subform/fruit-spirit-properties-subform.component';
import { GinPropertiesSubformComponent } from '../gin/gin-properties-subform/gin-properties-subform.component';
import { LiqueurPropertiesSubformComponent } from '../liqueur/liqueur-properties-subform/liqueur-properties-subform.component';
import { OtherSpiritPropertiesSubformComponent } from '../other-spirit/other-spirit-properties-subform/other-spirit-properties-subform.component';
import { RumPropertiesSubformComponent } from '../rum/rum-properties-subform/rum-properties-subform.component';
import { TequilaPropertiesSubformComponent } from '../tequila/tequila-properties-subform/tequila-properties-subform.component';
import { VodkaPropertiesSubformComponent } from '../vodka/vodka-properties-subform/vodka-properties-subform.component';
import { WhiskyPropertiesSubformComponent } from '../whisky/whisky-properties-subform/whisky-properties-subform.component';

@Component({
  selector: 'app-spirit-properties-subform',
  templateUrl: './spirit-properties-subform.component.html',
  styleUrls: ['./spirit-properties-subform.component.scss'],
})
export class SpiritPropertiesSubformComponent extends SubformBaseComponent {
  DICT_PATH = 'PRODUCTS.SPIRIT_PROPERTIES';

  spiritTypes = SpiritType;

  static subforms = [
    'cognacProperties',
    'whiskyProperties',
    'rumProperties',
    'ginProperties',
    'vodkaProperties',
    'liqueurProperties',
    'bitterProperties',
    'fruitSpiritProperties',
    'tequilaProperties',
    'otherSpiritProperties',
  ];

  static isSecondaryProductSheet = false;

  static buildForm(
    fb: FormBuilder,
    data: SpiritProperties | undefined,
    isSecondaryProductSheet: boolean
  ) {
    isSecondaryProductSheet = isSecondaryProductSheet;
    return fb.group({
      spiritType: [data?.spiritType, Validators.required],
      ...SpiritPropertiesSubformComponent._buildSubforms(
        fb,
        data,
        isSecondaryProductSheet
      ),
    });
  }

  static _buildSubforms(
    fb: FormBuilder,
    data: SpiritProperties | undefined,
    isSecondaryProductSheet: boolean
  ) {
    const selected = data?.spiritType;
    return {
      ...(selected == SpiritType.Cognac && {
        cognacProperties: CognacPropertiesSubformComponent.buildForm(
          fb,
          data?.cognacProperties,
          isSecondaryProductSheet
        ),
      }),
      ...(selected == SpiritType.Whisky && {
        whiskyProperties: WhiskyPropertiesSubformComponent.buildForm(
          fb,
          data?.whiskyProperties,
          isSecondaryProductSheet
        ),
      }),
      ...(selected == SpiritType.Rum && {
        rumProperties: RumPropertiesSubformComponent.buildForm(
          fb,
          data?.rumProperties
        ),
      }),
      ...(selected == SpiritType.Gin && {
        ginProperties: GinPropertiesSubformComponent.buildForm(
          fb,
          data?.ginProperties
        ),
      }),
      ...(selected == SpiritType.Vodka && {
        vodkaProperties: VodkaPropertiesSubformComponent.buildForm(
          fb,
          data?.vodkaProperties
        ),
      }),
      ...(selected == SpiritType.Liqueur && {
        liqueurProperties: LiqueurPropertiesSubformComponent.buildForm(
          fb,
          data?.liqueurProperties
        ),
      }),
      ...(selected == SpiritType.Bitter && {
        bitterProperties: BitterPropertiesSubformComponent.buildForm(
          fb,
          data?.bitterProperties
        ),
      }),
      ...(selected == SpiritType.FruitSpirit && {
        fruitSpiritProperties: FruitSpiritPropertiesSubformComponent.buildForm(
          fb,
          data?.fruitSpiritProperties,
          isSecondaryProductSheet
        ),
      }),
      ...(selected == SpiritType.Tequila && {
        tequilaProperties: TequilaPropertiesSubformComponent.buildForm(
          fb,
          data?.tequilaProperties
        ),
      }),
      ...(selected == SpiritType.Other && {
        otherSpiritProperties: OtherSpiritPropertiesSubformComponent.buildForm(
          fb,
          data?.otherSpiritProperties
        ),
      }),
    };
  }

  removeAllSubforms() {
    SpiritPropertiesSubformComponent.subforms.forEach((subformName) => {
      this.group.removeControl(subformName);
    });
  }

  hasAnySubform() {
    let result = false;
    SpiritPropertiesSubformComponent.subforms.forEach((subformName) => {
      result = result || this.group.contains(subformName);
    });
    return result;
  }

  onSpiritTypeSelected(selected?: SpiritType) {
    setTimeout(() => {
      if (this.group.touched) {
        if (this.hasAnySubform()) {
          // if the subform already exists, remove it
          this.removeAllSubforms();
          // update the DOM to remove any previously added subform components, forcing it to later create new ones
          this.changeDetector.detectChanges();
        }
        // build
        if (selected) {
          const subforms = SpiritPropertiesSubformComponent._buildSubforms(
            this.fb,
            { spiritType: selected },
            !!this.getRootCtrl('secondaryProductSheet')?.value
          );
          for (const [key, value] of Object.entries(subforms)) {
            this.group.addControl(key, value);
          }
        }
      }
    });
  }
}
